// Recidiviz - a data platform for criminal justice reform
// Copyright (C) 2024 Recidiviz, Inc.
//
// This program is free software: you can redistribute it and/or modify
// it under the terms of the GNU General Public License as published by
// the Free Software Foundation, either version 3 of the License, or
// (at your option) any later version.
//
// This program is distributed in the hope that it will be useful,
// but WITHOUT ANY WARRANTY; without even the implied warranty of
// MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
// GNU General Public License for more details.
//
// You should have received a copy of the GNU General Public License
// along with this program.  If not, see <https://www.gnu.org/licenses/>.
// =============================================================================

import { TargetStatus } from "~datatypes";
import { palette } from "~design-system";

export const TARGET_LINE_WIDTH = 2;

// not part of the design system palette
const DATAVIZ_GRAY = "#BFCCD2";
export const GOAL_COLORS: Record<TargetStatus, string> = {
  NEAR: palette.data.gold1,
  FAR: palette.data.crimson1,
  MET: DATAVIZ_GRAY,
};
